import { Flex } from 'antd';
import styled from 'styled-components';

export const HEADER_HEIGHT = '41px';
const TOP_BANNER_HEIGHT = '34px';

export const LayoutWrapper = styled.div`
  padding: ${HEADER_HEIGHT} var(--spacing-gutter) 0;
  background-color: var(--clr-body-bg);
  height: var(--viewport-height);
  min-height: var(--viewport-height);
  position: relative;

  &.onboarding-screen {
    background-color: var(--clr-container-bg);
  }

  &.has-top-banner {
    padding-top: calc(${HEADER_HEIGHT} + ${TOP_BANNER_HEIGHT});
    .notification-container {
      height: calc(var(--viewport-height) - 84px);
    }
  }

  .main-container {
    padding: var(--spacing-gutter) 0 0;
    height: 100%;
    position: relative;

    &:has(.scroll-page-gutter),
    &:has(.custom-tabs) {
      padding-top: 0;
    }
  }

  .main-header {
    padding: 10px var(--spacing-gutter);
    font-weight: 600;
    width: 100%;
    background: var(--clr-container-bg);
    position: fixed;
    top: 0;
    left: 0;
    font-size: 14px;
    color: var(--clr-title);
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 10;
    height: 41px;
    border-bottom: 1px solid var(--clr-border-grey-100);
    &.has-top-banner {
      top: 34px;
    }
  }
`;

export const UpdateCheckerContainer = styled(Flex)`
  padding: 5px 10px;
  background: var(--clr-green-100);
  position: fixed;
  top: 0;
  z-index: 1;
  width: 100%;
  left: 0;
  p {
    color: var(--clr-black);
  }
  .icon {
    font-size: 18px;
    color: var(--clr-black);
    flex-shrink: 0;
  }
  .ant-btn {
    border-color: var(--clr-green-200);
    background-color: var(--clr-green-200);
    color: var(--clr-white);
    height: 24px;
    min-width: 76px;
    &:not(:disabled):not(.ant-btn-disabled):hover {
      border-color: var(--clr-green-200);
      background-color: var(--clr-green-200);
      color: var(--clr-white);
    }
  }
`;
